import cn from 'classnames/bind'

import styles from './colors.module.scss'

const cx = cn.bind(styles)

const COLOR_PRIMARY = 'Primary' as const
const COLOR_SUCCESS = 'Success' as const
const COLOR_WARNING = 'Warning' as const
const COLOR_ERROR = 'Error' as const
const COLOR_GRAY = 'Gray' as const
const COLOR_LIGHTGRAY = 'LightGray' as const
const COLOR_DARKGRAY = 'DarkGray' as const
const COLOR_WHITE = 'White' as const
const COLOR_BLACK = 'Black' as const
const COLOR_TEXT = 'Text' as const
const COLOR_ACTION = 'Action' as const
const COLOR_GOLD = 'Gold' as const
const COLOR_BUTTON_PRIMARY = 'ButtonPrimary' as const

export const colorTypes = {
  COLOR_PRIMARY,
  COLOR_SUCCESS,
  COLOR_ERROR,
  COLOR_WARNING,
  COLOR_GRAY,
  COLOR_LIGHTGRAY,
  COLOR_DARKGRAY,
  COLOR_WHITE,
  COLOR_BLACK,
  COLOR_TEXT,
  COLOR_ACTION,
  COLOR_GOLD,
  COLOR_BUTTON_PRIMARY,
}

export const classByColoringType = (
  coloringType: 'stroke' | 'fill' | 'none',
  color: (typeof colorTypes)[keyof typeof colorTypes],
  disabled?: boolean,
): string => {
  if (coloringType === 'none') {
    return ''
  }
  const className = `${coloringType}${color}`
  return cx({ [className]: true, disabled })
}
